import {
    SET_ACADEMIC_PROGRAMS,
    SET_CONTRACT_TYPES,
    SET_SCHEDULES,
    SET_STATES,
    SET_COMPANY,
    SET_OFFERS,
    SET_OFFER,
    SET_APPLICATIONS,
    SET_EDITING_OFFER,
    SET_CANDIDATE,
    SET_OFFER_PREVIEW,
    SET_BUSINESS_SECTORS,
    SET_FORMATIVE_FAMILIES,
    SET_COMPANY_OFFERS_EMULATION,
    SET_COMPANY_OFFERS_COUNT,
    SET_COMPANY_CANDIDATES_COUNT, SET_COMPANY_OFFERS_APPLICATIONS_FILTER, SET_COMPANY_OFFERS_FILTER
} from "../actions/constants";
import { createReducer } from "../../../_common/common";
import {CompanyApplication, CompanyApplicationItem, CompanyOffer} from "../../../_api";
import offers from "../../../offers/offers";


export const companyReducer = createReducer(null, {
    [SET_COMPANY]: (state, student)=> student,
});

export const offersReducer = createReducer(null, {
    [SET_OFFERS]: (state, offers)=> offers,
});

export const companyOffersEmulationReducer = createReducer(null, {
   [SET_COMPANY_OFFERS_EMULATION]: (state, offers)  => offers,
});

export const companyOffersCountReducer = createReducer(null, {
   [SET_COMPANY_OFFERS_COUNT]: (state, offers) => offers,
});

export const companyCandidatesCountReducer = createReducer(null, {
   [SET_COMPANY_CANDIDATES_COUNT]: (state, candidates) => candidates,
});

export const companyOffersFilterReducer = createReducer(null, {
    [SET_COMPANY_OFFERS_FILTER]: (state, offers) => offers,
});

export const companyOffersApplicationFilterReducer = createReducer(null, {
   [SET_COMPANY_OFFERS_APPLICATIONS_FILTER]: (state, offers) => offers,
});

export interface OfferReducer{
    offerSelected: CompanyOffer|null,
    editingOffer: CompanyOffer|null,
    previewOffer: CompanyOffer|null,
    applications: CompanyApplicationItem[]
}

const initialState = {
    offerSelected:null,
    editingOffer:null,
    previewOffer: null,
    applications: []
} as OfferReducer;

export const offerSelectedReducer = createReducer(initialState, {
    [SET_OFFER]: (state, offerSelected)=>{

        if(typeof offerSelected?.benefits === 'string')
            offerSelected.benefits = JSON.parse(offerSelected.benefits as any);

        state.offerSelected = offerSelected;
        return state
    },
    [SET_EDITING_OFFER]: (state, editingOffer)=>{

        if(typeof editingOffer?.benefits === 'string')
            editingOffer.benefits = JSON.parse(editingOffer.benefits as any);

        state.editingOffer = editingOffer;
        return state
    },
    [SET_OFFER_PREVIEW]: (state, previewOffer)=>{

        if(typeof previewOffer?.benefits === 'string')
            previewOffer.benefits = JSON.parse(previewOffer.benefits as any);

        state.previewOffer = previewOffer;
        return state
    },
    [SET_APPLICATIONS]: (state, applications)=>{
        state.applications = applications;
        return state
    },
});



export const candidateReducer = createReducer({candidate: null}, {
    [SET_CANDIDATE]: (state, candidate)=> {
        state.candidate = candidate;
        return state
    },

});


///////////////////// FIXTURES

export const Fixtures = {
    states: null as {[key:string]:any}|null ,
    states_kn: null as [{key:string, name:string}]|null,
    academic_programs: null as {[key:string]:any}|null,
    academic_programs_kn: null as [{key:string, name:string}]|null,
    schedules: null as {[key:string]:any}|null,
    schedules_kn: null as [{key:string, name:string}]|null,
    contract_types: null as {[key:string]:any}|null,
    contract_types_kn: null as [{key:string, name:string}]|null,
    business_sectors: null as {[key:string]:any}|null,
    business_sectors_kn: null as [{key:string, name:string}]|null,
    formative_families: null as {[key:string]:any}|null,
    formative_families_kn: null as [{key:string, name:string}]|null
};

export const fixturesReducer = createReducer(Fixtures, {
    [SET_STATES]: (state, {dic, kn})=>{
        state.states = dic;
        state.states_kn = kn;
        return state;
    },
    [SET_ACADEMIC_PROGRAMS]: (state, {dic, kn})=>{
        state.academic_programs = dic;
        state.academic_programs_kn = kn;
        return state;
    },
    [SET_SCHEDULES]: (state, {dic, kn})=>{
        state.schedules = dic;
        state.schedules_kn = kn;
        return state;
    },
    [SET_CONTRACT_TYPES]: (state, {dic, kn})=>{
        state.contract_types = dic;
        state.contract_types_kn = kn;
        return state;
    },
    [SET_BUSINESS_SECTORS]: (state, {dic, kn})=>{
        state.business_sectors = dic;
        state.business_sectors_kn = kn;
        return state;
    },
    [SET_FORMATIVE_FAMILIES]: (state, {dic, kn})=>{
        state.formative_families = dic;
        state.formative_families_kn = kn;
        return state;
    }
});
